import axios from "axios";

const baseUrl =  process.env.REACT_APP_GITO_API_URL + "/charging-sites/ChargingSite";
//const baseUrl = "https://localhost:7241/ChargingSite";

const mappingBaseUrl =
  process.env.REACT_APP_GITO_API_URL + "/charging-sites/ChargingSiteThirdPartySystemMapping";
const chargingProfilesUrl =
    process.env.REACT_APP_GITO_API_URL + "/charging-sites/ChargingProfile";
const chargingCapacityUrl =
    process.env.REACT_APP_GITO_API_URL + "/charging-sites/ChargingSiteCapacity";

// Function to get all charging sites
export async function getAllChargingSites(apiAccessToken) {
  try {
    const response = await axios.get(`${baseUrl}/get-all-charging-sites`, {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${apiAccessToken}`,
      },
    });
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.detail || "Failed to fetch charging sites"
    );
  }
}

export async function getAllChargingSitesByOrganizationPublicId(organizationPublicId, apiAccessToken) {
  const suffix = organizationPublicId ? `/${organizationPublicId}` : "";
  try {
    const response = await axios.get(
      `${baseUrl}/get-all-charging-sites-by-organization-public-id${suffix}`,
      {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${apiAccessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.detail || "Failed to fetch charging sites"
    );
  }
}

export async function getAllChargingSitesForSessions(apiAccessToken) {
    try {
        const response = await axios.get(`${baseUrl}/get-charging-sites-for-session`, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${apiAccessToken}`,
            },
        });
        return response.data;
    } catch (error) {
        throw new Error(
            error.response?.data?.detail || "Failed to fetch charging sites for sessions"
        );
    }
}

export async function getAllChargingSitesForPartner(partnerPublicId, apiAccessToken) {
  try {
    const response = await axios.get(`${baseUrl}/get-charging-sites-for-partner/${partnerPublicId}`, {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${apiAccessToken}`,
      },
    });
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.detail || "Failed to fetch charging sites"
    );
  }
}

export async function getRemotePartyChargingSites(remotePartyPublicId, apiAccessToken) {
  try {
    const response = await axios.get(`${baseUrl}/get-remote-party-charging-sites/${remotePartyPublicId}`, {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${apiAccessToken}`,
      },
    });
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.detail || "Failed to fetch charging sites"
    );
  }
}

// Function to get all charging sites
export async function getAllNonConfiguredChargingSites(apiAccessToken) {
  try {
    const response = await axios.get(`${baseUrl}/get-all-nonconfigured-charging-sites`, {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${apiAccessToken}`,
      },
    });
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.detail || "Failed to fetch charging sites"
    );
  }
}

// Function to get a specific charging site by chargingSitePublicId
export async function getChargingSite(chargingSitePublicId, apiAccessToken) {
  try {
    const response = await axios.get(
      `${baseUrl}/get-charging-site/${chargingSitePublicId}`,
      {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${apiAccessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.detail || "Failed to fetch charging site"
    );
  }
}

// Function to create a new charging site
export async function createChargingSite(chargingSiteData, apiAccessToken) {
  try {
    const response = await axios.post(
      `${baseUrl}/create-charging-site`,
      chargingSiteData,
      {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${apiAccessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.detail || "Failed to create charging site"
    );
  }
}

// Function to update an existing charging site
export async function updateChargingSite(chargingSiteData, apiAccessToken) {
  try {
    console.log("Charging site data being sent to API:", chargingSiteData);

    const response = await axios.put(
      `${baseUrl}/update-charging-site`,
  chargingSiteData,
      {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${apiAccessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.detail || "Failed to update charging site"
    );
  }
}

// Function to delete a charging site by chargingSitePublicId
export async function deleteChargingSite(chargingSitePublicId, apiAccessToken) {
  try {
    const response = await axios.delete(
      `${baseUrl}/delete-charging-site/${chargingSitePublicId}`,
      {
        headers: {
          "Authorization": `Bearer ${apiAccessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.detail || "Failed to delete charging site"
    );
  }
}


// Function to get third-party system mapping for a charging site
export async function getChargingSiteThirdPartySystemMapping(
  chargingSitePublicId,
  apiAccessToken
) {
  try {
    const response = await axios.get(
      `${mappingBaseUrl}/get-charging-site-third-party-system-mapping-for-charging-s
ite/${chargingSitePublicId}`,
      {
        headers: {
          "Authorization": `Bearer ${apiAccessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.detail ||
        "Failed to fetch third-party system mapping"
    );
  }
}

// Function to add third-party system mapping for a charging site
export async function addChargingSiteThirdPartySystemMapping(
  mappingData,
  apiAccessToken
) {
  try {
    const response = await axios.post(
      `${mappingBaseUrl}/add-charging-site-third-party-system-mapping`,
      mappingData,
      {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${apiAccessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.detail || "Failed to add third-party system mapping"
    );
  }
}

// Function to update third-party system mapping for a charging site
export async function updateChargingSiteThirdPartySystemMapping(
  mappingData,
  apiAccessToken
) {
  try {
    const response = await axios.put(
      `${mappingBaseUrl}/update-charging-site-third-party-system-mapping`,
      mappingData,
      {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${apiAccessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.detail ||
        "Failed to update third-party system mapping"
    );
  }
}

// Function to delete third-party system mapping for a charging site
export async function deleteChargingSiteThirdPartySystemMapping(
  chargingSitePublicId,
  thirdPartySystemPublicId,
  thirdPartySystemExternalId,
  apiAccessToken
) {
  try {
    const response = await axios.delete(
      `${mappingBaseUrl}/delete-charging-site-third-party-system-mapping/${chargingSitePublicId}/${thirdPartySystemPublicId}/${thirdPartySystemExternalId}`,
      {
        headers: {
          "Authorization": `Bearer ${apiAccessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.detail ||
        "Failed to delete third-party system mapping"
    );
  }
}

export async function getSiteOpeningHours(
  chargingSitePublicId, apiAccessToken
) {
  try {
    const response = await axios.get(
      `${baseUrl}/get-charging-site-opening-hours/${chargingSitePublicId}`,
      {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${apiAccessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.detail || "Failed to fetch charging site opening hours"
    );
  }
}

export async function setSiteOpeningHours(
  chargingSitePublicIc, openingHoursData, apiAccessToken
) {
  try {
    console.log("Charging site opening hours data being sent to API:", openingHoursData);
    openingHoursData.chargingSitePublicId = chargingSitePublicIc;

    const response = await axios.put(
      `${baseUrl}/update-charging-site-opening-hours`,
      openingHoursData,
      {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${apiAccessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.detail || "Failed to update charging site opening hours"
    );
  }
}


export async function getAllChargingProfilesForSite(apiAccessToken, chargingSitePublicID) {
    try {
        const response = await axios.get(`${chargingProfilesUrl}/get-charging-profiles-by-chargingsite/${chargingSitePublicID}`, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${apiAccessToken}`,
            },
        });
        return response.data;
    } catch (error) {
        throw new Error(
            error.response?.data?.detail || "Failed to fetch charging profiles"
        );
    }
}

export async function getChargingSiteCapacity(apiAccessToken, chargingSitePublicID) {
    try {
        const response = await axios.get(`${chargingCapacityUrl}/get-charging-site-capacity/${chargingSitePublicID}`, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${apiAccessToken}`,
            },
        });
        return response.data;
    } catch (error) {
        throw new Error(
            error.response?.data?.detail || "Failed to fetch charging sites"
        );
    }
}

export async function updateChargingSiteCapacity(chargingSiteData, apiAccessToken, capacityPublicId) {
    try {

        const response = await axios.put(
            `${chargingCapacityUrl}/update-charging-site-capacity/${capacityPublicId}`,
            chargingSiteData,
            {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${apiAccessToken}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        throw new Error(
            error.response?.data?.detail || "Failed to update charging capacity"
        );
    }
}

export async function createChargingSiteCapacitySchedule(apiAccessToken, chargingSitePublicId, chargingSiteData) {
    try {

        const response = await axios.post(
            `${chargingCapacityUrl}/create-charging-site-capacity/${chargingSitePublicId}`,
            chargingSiteData,
            {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${apiAccessToken}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        throw new Error(
            error.response?.data?.detail || "Failed to update charging capacity"
        );
    }
}

export async function deleteChargingSiteCapacity(apiAccessToken, capacityPublicId) {
    try {

        const response = await axios.delete(
            `${chargingCapacityUrl}/delete-charging-site-capacity/${capacityPublicId}`,
            {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${apiAccessToken}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        throw new Error(
            error.response?.data?.detail || "Failed to delete charging capacity"
        );
    }
}

export async function getChargingSiteParkingSpaces(
  chargingSitePublicId,
  apiAccessToken
) {
  try {
    const response = await axios.get(
        `${baseUrl}/get-parking-spaces-by-chargingSitePublicId/${chargingSitePublicId}`,
      {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${apiAccessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.detail || "Failed to fetch charging site parking spaces"
    );
  }
}

export async function getAllChargingSitesOperators(apiAccessToken) {
    try {
        const response = await axios.get(`${baseUrl}/get-all-site-operators`, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${apiAccessToken}`,
            },
        });
        return response.data;
    } catch (error) {
        throw new Error(
            error.response?.data?.detail || "Failed to fetch charging site operators"
        );
    }
}
